import { KWELLO_ICON } from '../icon/KwelloSvgIcon';
import KwelloButton from 'common/components/KwelloButton/KwelloButton';
import './errorpage.scss';
import { useLocation } from 'react-router-dom';
import { APP_ROOT } from 'routes/routes.const';

function ReloadButton() {
  const { pathname } = useLocation();

  const onReload = () => {
    if (pathname.includes('/error')) {
      // If the user is on the error page, redirect to the home page
      return window.location.assign(APP_ROOT);
    }

    window.location.reload();
  };

  return (
    <KwelloButton
      themeColor="secondary"
      onClick={onReload}
      icon={KWELLO_ICON.RELOAD_ICON}
      size="large"
    >
      Reload
    </KwelloButton>
  );
}

export default ReloadButton;
